import {cs} from "@common/react/chain-services";
import {consumeContext} from "@common/react/context";
import {noun} from "@common/utils/plural";
import React from "react";
import {ConfirmDialog} from "../../../common/confirm-dialog/confirm-dialog";
import {CreateNewEnvDialog} from "../../../dashboard/layout/top-section/add/create-new-env-dialog";

export const CreateEnvService = ({next}) =>
    cs(
        consumeContext("tenant"),
        consumeContext("subscriptionBrief"),
        consumeContext("routing"),
        ["newEnvDialog", (_, next) => CreateNewEnvDialog({next})],
        [
            "confirmDialog",
            (_, next) =>
                ConfirmDialog({
                    next,
                    cancelText: "Contact Support",
                    submitText: "Learn More",
                    title: "Environment Limit Reached",
                }),
        ],
        ({newEnvDialog, subscriptionBrief, confirmDialog, routing, tenant: {environments}}) => {
            const currentPlan = subscriptionBrief?.value?.primaryPlanName;
            const limiter = subscriptionBrief?.value?.allowances.find((item) => item.$type == "EnvironmentLimiter");
            // const limit = limiter?.isMaximum ? limiter.value : null;
            const limit = null;

            return next({
                createEnv: async ({onDone}) => {
                    if (limit && environments.length >= limit) {
                        const resp = await confirmDialog.show({
                            description: `The ${currentPlan.replace("Plan", "plan")} allows for ${limit} ${noun(
                                limit,
                                "environment"
                            )}. If you would like to add another environment please upgrade your organization.`,
                        });

                        if (resp) {
                            routing.goto("account-management", {
                                setting: "organization-details",
                                tab: "billing",
                            });
                        }
                    } else {
                        const resp = await newEnvDialog.show({environments});
                        if (resp) {
                            onDone(resp);
                        }
                    }
                },
            });
        }
    );
